import * as React from 'react';
import * as _ from 'lodash';
import * as Model from '../../api/model';
import { Grid, CircularProgress, Paper, Table, TableHead, TableRow, TableCell, TableBody, Toolbar, Typography, Tooltip, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import WhiteVarietyEditItem from './WhiteVarietyEditItem';
import WhiteVarietyAddItem from './WhiteVarietyAddItem';
import { API } from '../../api';

//#region UI configuration
const strings = {
    title: 'White Varieties',
    addButton: 'Add',
    idColumn: 'Id',
    nameColumn: 'Name'
};
//#endregion

//#region Props & State
interface WhiteVarietiesPageProps { }
interface WhiteVarietiesPageState {
    loading: boolean;
    items: Model.WhiteVariety[];
    selected: null | number;
    add: boolean;
}

const initialState: WhiteVarietiesPageState = {
    loading: true,
    items: [],
    selected: null,
    add: false
};
//#endregion

class WhiteVarietiesPage extends React.Component<WhiteVarietiesPageProps, WhiteVarietiesPageState> {

    constructor(props: WhiteVarietiesPageProps) {
        super(props);

        this.state = initialState;
    }

    // #region Lifecycle
    componentDidMount(): void {
        API.whiteVariety.list().then(items => {
            this.setState({ loading: false, items });
        });
    }

    render() {
        const { loading, items, selected, add } = this.state;

        return (
            <React.Fragment>
                {loading && <Grid container={true} justify="center">
                    <CircularProgress />
                </Grid>}

                {!loading && <Paper>
                    <Toolbar>
                        <Grid container={true} justify="space-between" alignItems="center">
                            <Grid item={true}>
                                <Typography variant="title">{strings.title}</Typography>
                            </Grid>
                            <Grid item={true}>
                                <Tooltip title={strings.addButton}>
                                    <IconButton onClick={this.onAddClick}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Toolbar>

                    <Table>
                        <colgroup>
                            <col width="15%" />
                            <col width="80%" />
                            <col width="5%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell numeric={true}>{strings.idColumn}</TableCell>
                                <TableCell>{strings.nameColumn}</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {add && <WhiteVarietyAddItem onItemAdded={this.onItemAdded} onCancelItemAdd={this.onCancelItemAdd} />}
                            {items.map(item => (
                                <WhiteVarietyEditItem
                                    key={item.id}
                                    item={item}
                                    selected={selected === item.id}
                                    onItemSelected={this.onItemClick}
                                    onItemEdited={this.onItemEdited}
                                    onItemRemoved={this.onItemRemoved}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </Paper>}
            </React.Fragment>
        );
    }
    // #endregion

    // #region Private
    private onAddClick = () => {
        this.setState({ add: true });
    }

    private onItemClick = (id: number) => {
        const { selected } = this.state;
        if (selected !== id) {
            this.setState({ selected: id });
        } else {
            this.setState({ selected: null });
        }
    }

    private onItemRemoved = (id: number) => {
        const { items } = this.state;
        this.setState({ items: items.filter(value => value.id !== id) });
    }

    private onItemEdited = (model: Model.WhiteVariety) => {
        let { items } = this.state;

        items = items.map(item => {
            if (item.id === model.id) {
                return model;
            } else {
                return item;
            }
        });

        items = _.sortBy(items, [(o: Model.WhiteVariety) => (o.name)]);

        this.setState({ items, selected: null });
    }

    private onItemAdded = (model: Model.WhiteVariety) => {
        let { items } = this.state;
        items = items.concat(model);
        items = _.sortBy(items, [(o: Model.WhiteVariety) => (o.name)]);
        this.setState({ items, add: false });
    }

    private onCancelItemAdd = () => {
        this.setState({ add: false });
    }
    // #endregion
}

export default WhiteVarietiesPage;



// WEBPACK FOOTER //
// ./src/modules/whiteVariety/WhiteVarietiesPage.tsx